<template>
    <div>
        <page-header image="header1.jpg" title="Anfahrt"></page-header>
        <b-container class="container">
            <b-row>
                <b-col>
                    <b-card no-body>
                        <b-tabs card>
                        <b-tab title="Zu Fuß / Mit dem Auto zu Stand 1" active>
                            <b-card-text>
                                <iframe width="100%" height="480" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/directions?origin=48.816278%2C%209.420929&destination=48.820214%2C%209.412386&key=AIzaSyAhUZSzCnCfLv165exQrQexP8aeTgVKEhQ" allowfullscreen></iframe> 
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Mit öffentlichen Verkehrsmitteln zu Stand 1">
                            <b-card-text>
                                <iframe width="100%" height="480" scrolling="no" frameborder="0"
                                    marginwidth="0" marginheight="0" style="border: 0 none;"
                                    src="http://www.vvs.de/typo3conf/ext/t3w_vvs_efaaufhp/res/scripts/generator/?Name=Bergstra%C3%9Fe%2017&Location=Remshalden&Id=streetID:1500000170:17:8119090:-1:Bergstra%C3%9Fe:Remshalden:Bergstra%C3%9Fe::Bergstra%C3%9Fe::ANY:DIVA_SINGLEHOUSE:3530632:750795:NBWT:vvs&Width=500&CustomName=Weinprobe%20in%20den%20Weinbergen&Direction=anreise&NewWindow=1&ShowClock=1"></iframe>
                            </b-card-text>
                        </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
// @ is an alias to /src

import PageHeader from '@/components/PageHeader.vue';
export default {
  name: 'journey',
  components: {
      PageHeader
  }
}
</script>

<style scoped lang="scss">
</style>
